import { PhosphorCheckCircle, PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";

interface Props {
  compliance: server.dto.EInvoiceInvoiceV2Compliance;
}

const error: server.dto.EInvoiceInvoiceV2Compliances[] = [
  "senderCountryNotSupported",
  "senderNotEnabled",
  "recieverCompanyInformationMissing",
];

const warning: server.dto.EInvoiceInvoiceV2Compliances[] = [
  //"receiverCountryNotSupported",
  "receiverNotFoundOnPeppol"
];

const success: server.dto.EInvoiceInvoiceV2Compliances[] = [
  "receiverFoundOnPeppol",
];

export const EInvoiceInvoiceV2Compliance = (props: Props) => {
  return <div className="flex gap">
    {error.includes(props.compliance.value) && <PhosphorWarningCircle
      iconSize="large"
      iconWeight="fill"
      iconColor="error"
    />}

    {warning.includes(props.compliance.value) && <PhosphorWarningCircle
      iconSize="large"
      iconWeight="fill"
      iconColor="yellow"
    />}

    {success.includes(props.compliance.value) && <PhosphorCheckCircle
      iconSize="large"
      iconWeight="fill"
      iconColor="green" />}
    <div>
      <SmallDetails
        label={props.compliance.message}
        subLabel={props.compliance.messageSublabel}
      />
    </div>
  </div>
}